<div class="md-form form-inline form-group">
  <mat-form-field class="rule-type-input">
    <mat-label>{{label}}</mat-label>
    <mat-select (selectionChange)="selectSchema($event)" [value]="selected" placeholder="Select">
      <mat-option *ngFor="let schema of schemas" [value]="schema">{{schema.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
